<template>
  <base-nav
    class="navbar-top navbar-dark navbarcont"
    id="navbar-main"
    :show-toggle-button="false"
    expand
  >
  </base-nav>
</template>
<script>
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
// import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";

export default {
  components: {},
  data() {
    return {
      activeNotifications: false,
      showMenu: false,
      searchQuery: "",
      user: [],
      EUR: null,
      USD: null,
      dates: {
        simple: moment().format("YYYY-MM-DD"),
      },
    };
  },
  created() {
    this.user = firebase.auth().currentUser;
  },
  mounted() {
    this.getCurrency();
  },
  methods: {
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    logout() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          localStorage.clear();
          this.$router.replace("login");
        });
    },
    getCurrency() {
      this.EUR = null;
      this.USD = null;
      setTimeout(() => {
        fetch(
          "https://canplast.net:50000/api/v1/SAP/GET/currency/USD/" +
            moment(this.dates.simple).format("YYYYMMDD"),
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              "x-access-token": localStorage.getItem("token-cpm"),
            },
          }
        )
          .then((response) => response.json())
          .then((responseJson) => {
            this.USD = responseJson.USD;
          })
          .catch((error) => {
            console.error(error);
          });

        fetch(
          "https://canplast.net:50000/api/v1/SAP/GET/currency/EUR/" +
            moment(this.dates.simple).format("YYYYMMDD"),
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              "x-access-token": localStorage.getItem("token-cpm"),
            },
          }
        )
          .then((response) => response.json())
          .then((responseJson) => {
            this.EUR = responseJson.EUR;
          })
          .catch((error) => {
            console.error(error);
          });
      }, 500);
    },
    moment: function() {
      return moment();
    },
  },
};
</script>

<style>
#navbar-main {
  display: none;
}
</style>
